// Одновременная фаза снабжения сетевой игры: игрок уже завершил свою часть
// фазы и ждет остальных (как TEXT_SETUP_STARTING_QUARTER_WAIT_OTHERS в расстановке)
export const TEXT_SUPPLY_WAIT_OTHERS = 'Подожди, другие игроки еще не завершили фазу снабжения'
